var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTadaLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 26,
    viewBox: "0 0 134 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.4 20.53H113.32L111.54 24.3C111.29 24.8 111.16 24.84 110.67 24.84H105.74C105.699 24.8458 105.657 24.8425 105.617 24.8306C105.577 24.8186 105.54 24.7981 105.509 24.7706C105.477 24.7431 105.452 24.7091 105.435 24.6711C105.418 24.633 105.41 24.5917 105.41 24.55C105.432 24.3749 105.486 24.2055 105.57 24.05L117.25 0H121.55L133.23 24.05C133.314 24.2055 133.368 24.3749 133.39 24.55C133.39 24.5917 133.382 24.633 133.365 24.6711C133.348 24.7091 133.323 24.7431 133.291 24.7706C133.26 24.7981 133.223 24.8186 133.183 24.8306C133.143 24.8425 133.101 24.8458 133.06 24.84H128.14C127.64 24.84 127.52 24.84 127.27 24.3L125.4 20.53ZM115.3 16.14H123.5L119.5 7.14H119.25L115.3 16.14Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.71 20.53H57.62L55.84 24.3C55.59 24.8 55.47 24.84 54.97 24.84H50C49.959 24.8441 49.9176 24.8398 49.8783 24.8272C49.839 24.8146 49.8028 24.7941 49.7718 24.7669C49.7409 24.7397 49.7159 24.7064 49.6983 24.669C49.6808 24.6317 49.6712 24.5912 49.67 24.55C49.6962 24.3745 49.7538 24.2051 49.84 24.05L61.55 0H65.86L77.53 24.05C77.6162 24.2051 77.6738 24.3745 77.7 24.55C77.6988 24.5912 77.6892 24.6317 77.6717 24.669C77.6541 24.7064 77.6291 24.7397 77.5982 24.7669C77.5672 24.7941 77.5309 24.8146 77.4917 24.8272C77.4524 24.8398 77.411 24.8441 77.37 24.84H72.44C71.94 24.84 71.82 24.84 71.57 24.3L69.71 20.53ZM59.61 16.14H67.8L63.8 7.14H63.55L59.61 16.14Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2 24.84C81.0705 24.8307 80.9486 24.7751 80.8568 24.6832C80.7649 24.5914 80.7093 24.4695 80.7 24.34V0.5C80.7093 0.370463 80.7649 0.248612 80.8568 0.15678C80.9486 0.0649479 81.0705 0.00928747 81.2 0L91.67 0C99.53 0 105.41 4.84 105.41 12.42C105.41 20 100.41 24.84 91.75 24.84H81.2ZM86.33 4.72V20.12H91.75C97.01 20.12 99.75 17.12 99.75 12.42C99.75 7.72 96.36 4.72 91.64 4.72H86.33Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37 9.99999L11.83 8.10999L24 17.82C24.4507 18.8313 24.9824 19.8044 25.59 20.73L5.37 9.99999Z",
    fill: "#E95642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H18.5L22.69 6.53C22.4665 7.70692 22.3526 8.90204 22.35 10.1L13.5 0Z",
    fill: "#32BBCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21.85L7.13 18.16L30.58 25.83L30.65 25.89L0 21.85Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.87 0C51.9207 1.49426 52.7056 3.1587 53.19 4.92H42.86V24.92C40.9801 25.6061 38.9911 25.945 36.99 25.92V4.92H28.67L25.53 0H50.87Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTadaLogoLight);
export default __webpack_public_path__ + "static/media/tada-logo-light.2f00aa5fb550cb8302456243815c371a.svg";
export { ForwardRef as ReactComponent };